export default "__VITE_ASSET__C$ffW2sS__"